import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Lottie from "lottie-react";
import animationData from "../../animations/LoadingAnimation.json";
import "./index.css";

type PageLoaderContext = "login" | "program" | "generic";

interface PageLoaderProps extends WithTranslation {
  context?: PageLoaderContext;
  programName?: string;
}

function PageLoader({ context = "generic", programName = "", t }: PageLoaderProps) {
  let textKey = "page_loader.default";
  if (context === "login") {
    textKey = "page_loader.login";
  } else if (context === "program") {
    textKey = "page_loader.program";
  }
  const text = context === "program" ? t(textKey, { programName }) : t(textKey);

  return (
    <div className="spinner-container" role="status" aria-live="polite">
      <Lottie animationData={animationData} loop onError={() => console.warn("Failed to load loading animation")} />
      <div className="loader-text">
        {(() => {
          const lines = text.split("\n");
          const firstPart = lines[0];
          const secondPartLines = lines.slice(1);
          return (
            <>
              <div className="loader-text-first">{firstPart}</div>
              {secondPartLines.length > 0 && (
                <div className="loader-text-second">
                  {secondPartLines.map((line, index) => (
                    <div key={index}>{line}</div>
                  ))}
                </div>
              )}
            </>
          );
        })()}
      </div>
    </div>
  );
}

export default withTranslation()(PageLoader);
